import { useQuery } from '@tanstack/react-query'
import AuthApiService from 'services/AuthApiService'

export const useGetLicenses = () => {
	const { data, refetch, isError, isLoading } = useQuery({
		queryKey: ['groupsListLicense'],
		queryFn: async () => {
			return await AuthApiService.getLicenses()
		},
		staleTime: 50000,
		retry: 2,
	})

	return {
		data,
		isLoading,
		isError,
		refetch,
	}
}
